// extracted by mini-css-extract-plugin
export var container = "Testimonial-module--container--KPkHj";
export var quoteBox = "Testimonial-module--quoteBox--9Kr4T";
export var quote = "Testimonial-module--quote--9GZRf";